import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "pa-0 body2-text font-weight-regular text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_OrderDetailFulfillmentInfoBarogoTooltip = _resolveComponent("OrderDetailFulfillmentInfoBarogoTooltip");
    const _component_OrderDetailBaromoneyRemittanceInProgress = _resolveComponent("OrderDetailBaromoneyRemittanceInProgress");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card_actions = _resolveComponent("v-card-actions");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_row = _resolveComponent("v-row");
    const _component_Chip = _resolveComponent("Chip");
    return (_ctx.hasOrder)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            flat: "",
            tile: "",
            class: "pa-0 fulfillment-info"
        }, {
            default: _withCtx(() => [
                _createCommentVNode(" 담당 라이더 "),
                (_ctx.isAllocatedWorkerShow)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "mb-4 fulfillment-info__item"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'allocated_worker')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                        flat: "",
                                        tile: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                                default: _withCtx(() => [
                                                    _createCommentVNode(" 라이더 소속 "),
                                                    _createVNode(_component_OrderDetailFulfillmentInfoBarogoTooltip, {
                                                        "allocated-hub-name": _ctx.order.allocatedHubName,
                                                        "worker-name": _ctx.order.workerName
                                                    }, null, 8 /* PROPS */, ["allocated-hub-name", "worker-name"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            (!_ctx.isHQ && (_ctx.isShowRemittanceBaromoneyBtn || _ctx.isMobile))
                                                ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                                    key: 0,
                                                    class: "d-block pt-3 pb-0 px-0"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createCommentVNode(" 라이더 바로머니 송금 버튼 "),
                                                        (_ctx.isShowRemittanceBaromoneyBtn)
                                                            ? (_openBlock(), _createBlock(_component_OrderDetailBaromoneyRemittanceInProgress, {
                                                                key: 0,
                                                                "delivery-id": _ctx.deliveryId,
                                                                "is-pickup-info-card": false
                                                            }, null, 8 /* PROPS */, ["delivery-id"]))
                                                            : _createCommentVNode("v-if", true),
                                                        (_ctx.isMobile)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 1,
                                                                variant: "outlined",
                                                                color: "blue-grey darken-1",
                                                                href: `tel:${_ctx.allocatedWorkerPhone}`,
                                                                class: "me-1",
                                                                width: _ctx.buttonWidth
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('common.phone')), 1 /* TEXT */)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["href", "width"]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 라이더 전화번호 "),
                (_ctx.isAllocatedWorkerShow)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": "",
                        class: "mb-4 fulfillment-info__item"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'phone')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.allocatedWorkerPhone), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 주의사항 "),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mb-4 fulfillment-info__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'caveats')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0" }, {
                                    default: _withCtx(() => [
                                        (_ctx.isUntact)
                                            ? (_openBlock(), _createBlock(_component_Chip, {
                                                key: 0,
                                                "brg-chip-color": "blue",
                                                text: _ctx.$t('views.order_detail.order_detail_fulfillment_info.untact')
                                            }, null, 8 /* PROPS */, ["text"]))
                                            : _createCommentVNode("v-if", true),
                                        (_ctx.isAlcohol)
                                            ? (_openBlock(), _createBlock(_component_Chip, {
                                                key: 1,
                                                "brg-chip-color": "red",
                                                text: _ctx.$t('views.order_detail.order_detail_fulfillment_info.alcohol')
                                            }, null, 8 /* PROPS */, ["text"]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" 특이사항 "),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "fulfillment-info__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'memo')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.order.memo), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        }))
        : _createCommentVNode("v-if", true);
}
